
// import React, { useState, useEffect } from "react";
// import Layout from "../components/Layout";
// import axios from "axios";

// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// import { Dropdown } from "primereact/dropdown";

// import {
//   DigitizeTrendApi,
//   KickwinTrendApi,
//   trendApi,
//   visionGamestrendApi,
//   WondermindTrendApi,
// } from "../Data/api";

// const CheckHourlyLogs = () => {
//   const services = [
//     { name: "kiddoCraze", code: "KC", api: trendApi },
//     { name: "VisionGames", code: "VG", api: visionGamestrendApi },
//     { name: "DigitizeAi", code: "DA", api: DigitizeTrendApi },
//     { name: "WonderMind", code: "WM", api: WondermindTrendApi },
//     { name: "KickWin", code: "KW", api: KickwinTrendApi },
//   ];

//   const [selectedService, setSelectedService] = useState(services[0]);
//   const [date, setDate] = useState(new Date());
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const formatDate = (inputDate) => {
//     return inputDate.toLocaleDateString("en-CA");
//   };

//   const fetchData = async (selectedDate, service) => {
//     setLoading(true);
//     setError(null);

//     try {
//       const formattedDate = formatDate(selectedDate);
//       const response = await axios.post(service.api, {
//         date: formattedDate,
//       });

//       if (response.data && response.data.results) {
//         setData(response.data.results);
//       } else {
//         setData([]);
//       }
//     } catch (fetchError) {
//       console.error("Trend fetch error:", fetchError);
//       setError("Error fetching trend data. Please try again later.");
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(date, selectedService);
//   }, [date, selectedService]);

//   return (
//     <Layout>
//       <div className="min-h-screen bg-gray-50 px-4 py-8">
//         <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-md p-5 md:p-8">
//           <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
//             {selectedService.name.toUpperCase()} TRACKING TREND
//           </h1>

//           <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8">
//             <DatePicker
//               selected={date}
//               onChange={(newDate) => setDate(newDate)}
//               dateFormat="yyyy-MM-dd"
//               className="w-full md:w-60 h-12 border border-gray-300 rounded-xl text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />

//             <div className="w-full md:w-60">
//               <Dropdown
//                 value={selectedService}
//                 onChange={(e) => setSelectedService(e.value)}
//                 options={services}
//                 optionLabel="name"
//                 placeholder="Select Service"
//                 className="w-full border rounded-xl"
//               />
//             </div>
//           </div>

//           {loading && (
//             <div className="flex justify-center my-10">
//               <div className="w-14 h-14 border-4 border-blue-500 border-dashed rounded-full animate-spin" />
//             </div>
//           )}

//           {error && (
//             <p className="text-center text-red-600 font-semibold">{error}</p>
//           )}

//           {!loading && !error && (
//             <div className="overflow-x-auto">
//               <DataTable value={data} className="border rounded-xl overflow-hidden min-w-[700px]">
//                 <Column field="date" header="Date" />
//                 <Column header="03:30 AM - 09:30 AM" body={(row) => row.REN?.[0] ?? 0} />
//                 <Column header="09:30 AM - 03:30 PM" body={(row) => row.REN?.[1] ?? 0} />
//                 <Column header="03:30 PM - 09:30 PM" body={(row) => row.REN?.[2] ?? 0} />
//                 <Column header="09:30 PM - 03:30 AM" body={(row) => row.REN?.[3] ?? 0} />
//               </DataTable>
//             </div>
//           )}
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default CheckHourlyLogs;



import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import axios from "axios";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { Dropdown } from "primereact/dropdown";

import {
  DigitizeTrendApi,
  KickwinTrendApi,
  trendApi,
  visionGamestrendApi,
  WondermindTrendApi,
} from "../Data/api";

const CheckHourlyLogs = () => {
  const services = [
    { name: "kiddoCraze", code: "KC", api: trendApi },
    { name: "VisionGames", code: "VG", api: visionGamestrendApi },
    { name: "DigitizeAi", code: "DA", api: DigitizeTrendApi },
    { name: "WonderMind", code: "WM", api: WondermindTrendApi },
    { name: "KickWin", code: "KW", api: KickwinTrendApi },
  ];

  const [selectedService, setSelectedService] = useState(services[0]);
  const [date, setDate] = useState(new Date());
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const formatDate = (inputDate) => {
    return inputDate.toLocaleDateString("en-CA");
  };

  const fetchData = async (selectedDate, service) => {
    setLoading(true);
    setError(null);

    try {
      const formattedDate = formatDate(selectedDate);
      const response = await axios.post(service.api, {
        dates: formattedDate,
      });

      if (response.data && response.data.results) {
        setData(response.data.results);
      } else {
        setData([]);
      }
    } catch (fetchError) {
      console.error("Trend fetch error:", fetchError);
      setError("Error fetching trend data. Please try again later.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(date, selectedService);
  }, [date, selectedService]);

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 px-4 py-8">
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-md p-5 md:p-8">
          <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
            {selectedService.name.toUpperCase()} TRACKING TREND
          </h1>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8">
            <DatePicker
              selected={date}
              onChange={(newDate) => setDate(newDate)}
              dateFormat="yyyy-MM-dd"
              className="w-full md:w-60 h-12 border border-gray-300 rounded-xl text-center focus:outline-none focus:ring-2 focus:ring-blue-500"
            />

            <div className="w-full md:w-60">
              <Dropdown
                value={selectedService}
                onChange={(e) => setSelectedService(e.value)}
                options={services}
                optionLabel="name"
                placeholder="Select Service"
                className="w-full border rounded-xl"
              />
            </div>
          </div>

          {loading && (
            <div className="flex justify-center my-10">
              <div className="w-14 h-14 border-4 border-blue-500 border-dashed rounded-full animate-spin" />
            </div>
          )}

          {error && (
            <p className="text-center text-red-600 font-semibold">{error}</p>
          )}

          {!loading && !error && (
            <div className="overflow-x-auto">
              <DataTable value={data} className="border rounded-xl overflow-hidden min-w-[700px]">
                <Column field="date" header="Date" />
                {/* <Column header="03:30 AM - 09:30 AM" body={(row) => row.REN?.[0] ?? 0} />
                <Column header="09:30 AM - 03:30 PM" body={(row) => row.REN?.[1] ?? 0} />
                <Column header="03:30 PM - 09:30 PM" body={(row) => row.REN?.[2] ?? 0} />
                <Column header="09:30 PM - 03:30 AM" body={(row) => row.REN?.[3] ?? 0} /> */}
                <Column
  header="12 AM - 11 AM"
  body={(row) => row.REN?.[0] ?? 0}
/>

<Column
  header="11 AM - 3 PM"
  body={(row) => row.REN?.[1] ?? 0}
/>

<Column
  header="3 PM - 7 PM"
  body={(row) => row.REN?.[2] ?? 0}
/>

<Column
  header="Total REN"
  body={(row) => row.REN?.[3] ?? 0}
/>
              </DataTable>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CheckHourlyLogs;
